import React, { useContext, useEffect, useState } from "react";
import Cookies from "js-cookie";
import { FetchDataTypes } from "../api/api";
import { Line } from "react-chartjs-2";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import {
  SectorAllocationTblComumns,
  SectorAllocationTblRightColumns,
} from "../columns/PerformanceColumns";
import {
  Chart,
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement,
  Filler,
} from "chart.js";
import { Pagination } from "../components";

import groupBy, { concat } from "lodash";
import _ from "lodash";
import { CellClickedEvent } from "ag-grid-community";
Chart.register(
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement,
  Filler
);

function IndustriesAllocation({ chartTitle }: { chartTitle: string }) {
  const [sectorAllocation, setSectorAllocation] = useState<any>(null);
  const [sectorDetails, setSectorDetails] = useState<any>(null);
  const [sectorCount, setSectorCount] = useState<any>(null);
  const [SectorCurrentPage, setSectorCurrentPage] = useState(1);
  const [getIndustryName, setGetIndustryName] = useState(null);
  const [gridApi, setGridApi] = useState<any>(null);
  const [gridColumnApi, setGridColumnApi] = useState(null);
  const [allocationsByIndustry, setAllocationsByIndustry] = useState(null);
  const selectedClient:any = Cookies.get("client")
  // useEffect(() => {
  //   FetchDataTypes("SectorActivity", Cookies.get("newJwt"))
  //     .then((response) => response.json())
  //     .then((response) => {
  //       setSectorAllocation(response);
  //     });
  // }, []);

  useEffect(() => {
    FetchDataTypes("AllocationsDashboard", parseInt(selectedClient),Cookies.get("newJwt"))
      .then((response) => response.json())
      .then((response) => {
        setSectorDetails(response);
        setSectorCount(response);
      });
  }, []);

  useEffect(() => {
    FetchDataTypes("AllocationsByIndustry", parseInt(selectedClient),Cookies.get("newJwt"))
      .then((response) => response.json())
      .then((response) => {
        setAllocationsByIndustry(response);
        setSectorCount(response);
      });
  }, []);
  const newData = sectorDetails?.filter(
    (filter_by: { industryName: null }) =>
      filter_by.industryName === getIndustryName
  );

  const SectorpageHandler = (pageNumbers: any, index: any) => {
    setSectorDetails(
      sectorCount.slice(pageNumbers * 10 - 10, pageNumbers * 10)
    );
    setSectorCurrentPage(pageNumbers);
  };

  function formateAsPercent(num: any) {
    return new Intl.NumberFormat("default", {
      style: "percent",
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(num / 100);
  }

  function formateDataPrec(p: any) {
    return p.value >= 0 ? (
      <>{p.value === null ? "NA" : formateAsPercent(p.value)}</>
    ) : (
      <>
        <span className="text-danger">
          {"(" + formateAsPercent(p.value).slice(1) + ")"}
        </span>
      </>
    );
  }
  function currencyFormat(num: any) {
    return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }

  function formateDataCurr(p: any) {
    return p.value >= 0 ? (
      <>{p.value === null ? "NA" : "$" + currencyFormat(p.value)}</>
    ) : (
      <>
        <span className="text-danger">
          {"(" + "$" + currencyFormat(p.value).slice(1) + ")"}
        </span>
      </>
    );
  }
  function formateDatabuyCurr(p: any) {
    return p.value >= 0 ? (
      <>
        {p.value === null ? (
          "NA"
        ) : (
          <span className="text-success ">{"$" + currencyFormat(p.value)}</span>
        )}
      </>
    ) : (
      <>
        <span className="text-danger">
          {"(" + "$" + currencyFormat(p.value).slice(1) + ")"}
        </span>
      </>
    );
  }

  function onGridReady(params: any) {
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
  }
  const handleChange = (e: any) => {
    gridApi.setQuickFilter(e.target.value);
  };

  const IndustryAllocationTblComumns = [
    {
      field: "industryname",
      headerName: "Industry Name",
      width: 230,
      resizable: true,
      sortable: true,
      cellClass: "cell-wrap-text",
      flex: 1,
      filter: "agSetColumnFilter",
      floatingFilter: true,
      onCellClicked: (event: CellClickedEvent) =>
        setGetIndustryName(event.value),
    },

    {
      field: "balanceByIndustry",
      headerName: "Balance",
      width: 80,
      cellClass: "cell-wrap-text",
      cellRenderer: formateDataCurr,
      //headerClass: "headerTextAlign",
    },
    {
      field: "industryHoldingsPct",
      headerName: "%",
      cellRenderer: formateDataPrec,
      width: 130,
      cellClass: "cell-wrap-text textAlign",
      headerClass: "headerTextAlign",
    },
  ];
  const IndistryAllocationTblRightColumns = [
    {
      field: "symbol",
      headerName: "Symbol",
      width: 100,
      sortable: true,
      cellClass: "cell-wrap-text",
      //flex: 1,
      floatingFilter: true,
filter: "agTextColumnFilter",
    },

    {
      field: "qty",
      headerName: "Qty",
      width: 60,
      cellClass: "cell-wrap-text",
      //cellRenderer: formateDataCurr,
      //headerClass: "headerTextAlign",
    },
    {
      field: "price",
      headerName: "Price",
      cellRenderer: formateDataCurr,
      width: 100,
      cellClass: "cell-wrap-text textAlign",
      headerClass: "headerTextAlign",
    },
    {
      field: "marketValue",
      headerName: "Market Value",
      cellRenderer: formateDataCurr,
      width: 130,
      cellClass: "cell-wrap-text textAlign",
      headerClass: "headerTextAlign",
    },
    {
      field: "securityHoldingsPct",
      headerName: "Holdings %",
      cellRenderer: formateDataPrec,
      width: 100,
      cellClass: "cell-wrap-text textAlign",
      headerClass: "headerTextAlign",
    },
    {
      field: "securityHoldingsPctInIndustry",
      headerName: "%",
      cellRenderer: formateDataPrec,
      width: 100,
      cellClass: "cell-wrap-text textAlign",
      headerClass: "headerTextAlign",
    },
  ];
  return (
    <div className="row w-100">
      <div className="card mr-2" style={{ width: "42%", marginRight: "15px" }}>
        <div className="d-inline-block col-sm-3 w-100 py-3">
          <input
            type="text"
            id="filter-text-box"
            placeholder="Search..."
            onInput={handleChange}
            className="form-control float-end w-50"
          />
        </div>
        <div className="card-body">
          <div className="chart chart-xs">
            <div className="chartjs-size-monitor">
              <div className="chartjs-size-monitor-shrink">
                <div
                  className="ag-theme-alpine"
                  style={{
                    height: "600px",
                    width: "100%",
                  }}
                >
                  <AgGridReact
                    onGridReady={onGridReady}
                    rowData={allocationsByIndustry}
                    columnDefs={IndustryAllocationTblComumns}
                    rowHeight={40}
                    pagination={true}
                  paginationPageSize= {20}
                  //paginationAutoPageSize={true}
                  />
                </div>
              
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card" style={{ width: "56%" }}>
        <div className="d-flex col-sm-3 pt-4 w-100 ps-3 selectedName">
          {newData &&
            newData?.map((e: any) => {
              return <span>Industry:&nbsp;&nbsp; {e.industryName}</span>;
            })}{" "}
        </div>
        <div className="card-body">
          <div className="chart chart-xs">
            <div className="chartjs-size-monitor">
              <div className="chartjs-size-monitor-shrink">
                <div
                  className="ag-theme-alpine"
                  style={{
                    height: "600px",
                    width: "100%",
                  }}
                >
                  <AgGridReact
                    rowData={
                      newData && newData.length ? newData : sectorDetails
                    }
                    columnDefs={IndistryAllocationTblRightColumns}
                    rowHeight={40}
                    pagination={true}
                  paginationPageSize= {20}
                  //paginationAutoPageSize={true}
                  />
                </div>
               
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export { IndustriesAllocation };
